var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.235 89.806 c -0.267 0 -0.533 -0.102 -0.737 -0.305 c -0.407 -0.407 -0.407 -1.066 0 -1.473 L 13.697 74.83 c 0.407 -0.407 1.066 -0.407 1.473 0 s 0.407 1.066 0 1.473 L 1.972 89.501 C 1.768 89.704 1.502 89.806 1.235 89.806 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.8 89.806 c -0.267 0 -0.533 -0.102 -0.737 -0.305 c -0.407 -0.407 -0.407 -1.066 0 -1.473 l 7.416 -7.416 c 0.407 -0.407 1.066 -0.407 1.473 0 s 0.407 1.066 0 1.473 l -7.416 7.416 C 13.334 89.704 13.067 89.806 12.8 89.806 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.235 78.242 c -0.267 0 -0.533 -0.102 -0.737 -0.305 c -0.407 -0.407 -0.407 -1.066 0 -1.473 l 7.416 -7.416 c 0.407 -0.407 1.066 -0.407 1.473 0 s 0.407 1.066 0 1.473 l -7.416 7.416 C 1.768 78.14 1.502 78.242 1.235 78.242 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.299 0.016 L 77.432 1.586 C 67.023 3.091 57.38 7.922 49.944 15.359 l -14.64 14.64 l -13.192 -1.166 c -1.977 -0.175 -3.93 0.535 -5.333 1.939 L 0.344 47.206 c -0.702 0.702 -0.265 1.903 0.724 1.991 l 13.817 1.221 l 4.384 4.384 l -4.067 6.669 c -0.644 1.055 -0.481 2.414 0.393 3.288 l 9.646 9.646 c 0.874 0.874 2.233 1.036 3.288 0.393 l 6.669 -4.067 l 4.384 4.384 l 0.023 -0.023 l 1.198 13.84 c 0.087 0.988 1.289 1.425 1.991 0.724 l 16.434 -16.434 c 1.403 -1.403 2.113 -3.356 1.939 -5.333 L 59.997 54.7 l 14.644 -14.644 c 7.437 -7.437 12.268 -17.079 13.772 -27.488 l 1.571 -10.867 C 90.126 0.717 89.283 -0.126 88.299 0.016 z M 64.571 37.529 c -3.341 3.341 -8.759 3.341 -12.1 0 c -3.341 -3.341 -3.341 -8.759 0 -12.1 c 3.341 -3.341 8.759 -3.341 12.1 0 C 67.913 28.77 67.913 34.187 64.571 37.529 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.5e889f9109605016266d8f96e67fd599.svg";
export { ForwardRef as ReactComponent };